module.exports = __webpack_public_path__ + "static/media/video1.efa246ce.mp4";